import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-number-one-icon',
  templateUrl: './number-one-icon.component.html',
  styles: []
})
export class NumberOneIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
